export function clearEmptyProperties<T>(data: { [i: string]: string | number | null }) {
  Object.keys(data).forEach((i) => !data[i] && delete data[i]);
  return data as T;
}
